import { Breakpoints, Card, styled } from '@volkswagen-onehub/components-core';

export const SlideCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 280px;
  border-radius: 0px;
  overflow: hidden;
  background: transparent;
  transition: height 0.1s ease;
  box-shadow: none;
  padding: 0;

  @media (min-width: ${Breakpoints.b560}px) {
    height: 320px;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    height: 360px;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    height: 400px;
  }
`;

export const SlideMediaWrapper = styled.div`
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
`;

export const SlideImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: none;
  border-radius: 0;
  transition: transform 0.3s ease;
`;

export const SlideVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: none;
  border-radius: 0;
  background: transparent;
`;

export const SlideContent = styled.div`
  flex-shrink: 0;
  overflow-y: auto;
  padding: 0px;

  ${(props) =>
    !props.hasMedia
      ? `
      height: 100%; 
      display: flex;
      flex-direction: column; 
      justify-content: center; 
      align-items: center;
      padding: 12px;`
      : `height: 80px;`}
`;

export const LentilsWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
`;
